import Box from '@mui/material/Box'
import { authTopChromeSx } from '../styles/authChromeStyles'

type AuthTopAppBarProps = {
  readonly variant?: 'card' | 'split'
}

/** Figma 5074-11761 / 5074-12131 — empty 64px top bar (no app title). Hidden on phones. */
export function AuthTopAppBar({ variant = 'card' }: AuthTopAppBarProps) {
  return (
    <Box
      component="header"
      role="banner"
      data-testid="auth-top-app-bar"
      data-auth-chrome-variant={variant}
      aria-label="Auth header"
      sx={{
        ...authTopChromeSx,
        ...(variant === 'split'
          ? { display: { xs: 'none', md: 'block' } }
          : { '@media (max-width: 599.95px)': { display: 'none' } }),
      }}
    />
  )
}
